<template>
        <section
          class="px-1 mx-0 cursor-pointer pt-1 mt-1 d-flex flex-column col-xxs-12 col-md-4 col-sm-6 col-lg-3 align-items-center align-items-stretch"
        >
        <b-link :to="'/genre/'+item.id" class="no-underline text-decoration-none">
          <div class="card-shadow text-white d-flex text-center flex-column justify-content-center bg-white genre-card"
          >
            <i v-if="item.icon" :class="['icon display-4 p-3 text-white', `icon-${item.icon}`]"/>
            <i v-else class="icon display-4 icon-profile-game-controller-inactive" />
          <h5 class="">
              {{ item.name }}
          </h5>
          </div>
          </b-link>
        </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'GenresList',
    props:{
        item: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters({
        fileUrl: 'cdn/fileUrl'
    })
    }
}
</script>